import {ChangeDetectionStrategy, Component, HostListener, Input, OnChanges, OnInit} from '@angular/core';
import {getSecurityNameOrExchange} from '../../../../../../../../common/display-symbol';
import {TypedSimpleChanges} from '../../../../../../../../common/typed-on-changes';
import {Widget} from '../../../../../../../../components/layout/widget/widget';
import {WidgetLinkingGroupService} from '../../../../../../../../components/widget-linking-group';
import {WidgetLinkingGroupId} from '../../../../../../../../enums/widget-linking-group';
import {Security} from '../../../../../../../../models/security';
import {clearSecurityKey} from '../../../../../../../../models/security-key';
import {WidgetSettingsWithSecurityKey} from '../../../../../../../../widgets/components/common-widget.implementation';
import {WHeaderTitlePartSymbolData} from './w-header-title-part-symbol';

@Component({
    selector: 'w-header-title-part-symbol',
    templateUrl: './w-header-title-part-symbol.component.html',
    styleUrls: ['./w-header-title-part-symbol.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WHeaderTitlePartSymbolComponent implements OnInit, OnChanges {

    @Input()
    public data: WHeaderTitlePartSymbolData;

    @Input()
    public widget: Widget;

    // [TT-247] Handle Smart security (workaround) in Chart
    public altExchange: string;

    constructor(
        private widgetLinkingGroupService: WidgetLinkingGroupService
    ) {}

    public ngOnInit(): void {
        this.updateAltExchange();
    }

    public ngOnChanges(changes: TypedSimpleChanges<WHeaderTitlePartSymbolComponent>): void {
        if (changes.altExchange && !changes.altExchange.firstChange) {
            this.updateAltExchange();
        }
    }

    @HostListener('click')
    public handleClick(): void {
        const widget = this.widget;
        const securityKey = this.data.securityKey;

        const isWidgetActive = widget.cell.activeWidget === widget;
        const linkingGroupId = widget.linkingGroupId || WidgetLinkingGroupId.ALL;

        if (isWidgetActive && securityKey) {
            this.widgetLinkingGroupService.setLinkingGroupSettings(
                linkingGroupId,
                widget.tabId,
                {
                    securityKey: clearSecurityKey(securityKey)
                } as WidgetSettingsWithSecurityKey
            );
        }
    }

    private updateAltExchange(): void {
        this.altExchange = (this.data && this.data.altSecurityKey)
            ? getSecurityNameOrExchange(this.data.altSecurityKey as Security)
            : undefined;
    }

}
